import { cloneDeep, isMatch, snakeCase } from 'lodash';

export class ReportCalc {
  /**
   * 
   * @param model report model
   * @param shop report shop (optional, needed only for getAvailableCabins)
   */
  constructor(private model, private shop = {}) {
    
  }

  buildProductsTableStructure() {
    var soldProducts = this.getProductsForAssistant(this.model.assistants[0]);
    return {
      head: {
        products: soldProducts.map(soldProduct => soldProduct.product.name)
      },
      body: {
        rows: this.model.assistants.map(assistant => {
          var products = this.getProductsForAssistant(assistant);
          return {
            assistant: assistant,
            products: products.map(p => {
              return {
                price: p.product.price,
                name: p.product.name,
                soldProduct: p
              };
            }),
            total: products.reduce((total, product) => {
              return total + (product.quantity * product.product.price);
            }, 0)
          }
        })
      }
    };
  }

  getProductsForAssistant(assistant) {
    return this.model.products.filter(soldProduct => this.compareSchema(soldProduct.assistant, assistant));
  }
  getAvailableCabins() {
    var result = [];
    // console.log('getAvailableCabins', this.currentShop, this.originalModel);
    if (this.shop || this.shop === false) {
      for (let i = 0; i < 4; i++) {
        if (this.shop['hasCabin' + (i + 1)] || this.model['cabin' + (i + 1) + 'Pulse'] > 0) {
          result.push('cabin' + (i + 1) + 'Pulse');
        }
      }
    }
    return result;
  }
  productsTotalFor(assistant, index = -1) {
    return this.model.products.filter(soldProduct => this.compareSchema(soldProduct.assistant, assistant) && soldProduct.quantity > 0)
      .reduce((a, b) => {
        return a + b.quantity * b.product.price
      }, 0);
  }
  serviceTotal(service, index = -1) {
    // console.log('total service', service);
    return this.calculateSoldServiceTotal(service);
  }
  getTotal() {
    let assistantProductsTotal = this.model.products
      .filter(soldProduct => soldProduct.quantity > 0)
      .map(soldProduct => soldProduct.product.price * soldProduct.quantity)
      .reduce((a, b) => a + b, 0);
    let servicesTotal = this.model.services
      .filter(soldService => soldService.quantity > 0)
      .map(soldService => this.calculateSoldServiceTotal(soldService))
      .reduce((a, b) => a + b, 0);
    return assistantProductsTotal + servicesTotal;
  }
  getDailyEarnings() {
    const cashMoney = this.getTotal() -
      (this.model.deposit
        //+ this.model.bills
        //+ this.model.coins
        + this.model.totalPos
      );
    // return cashMoney
    return Number.parseFloat(cashMoney + '').toPrecision(2)
      ;
  }
  getDifference() {
    const cashMoney = (this.getTotal() + (this.model.startCash || 0)) -
      (this.model.deposit
        + this.model.bills
        + this.model.coins
        + this.model.totalPos
      );
    // return cashMoney
    return Number.parseFloat(cashMoney + '').toPrecision(2)
      ;
  }

  protected calculateSoldServiceTotal(soldService) {
    let offerData = 0;
    soldService.offers.forEach((offer, i) => {
      offerData += soldService.offersQuantity[i] * (offer.discount * soldService.service.price) / 100;
    })
    return (soldService.service.price * soldService.quantity) - offerData;
  }
  protected compareSchema(el1, el2) {
    return el1._id === el2._id;
  }
}



// WEBPACK FOOTER //
// ./client/services/report.class.ts